// src/hooks/useTelegram.js

import { useEffect, useState } from "react";

const TELEGRAM_READY_EVENT = "telegram-webapp-ready";

function readTelegramState() {
  const tg = typeof window !== "undefined" ? window.Telegram?.WebApp || null : null;
  const isRealTelegram =
    !!tg &&
    !!tg.initDataUnsafe &&
    !!tg.initDataUnsafe.user &&
    typeof tg.initDataUnsafe.user.id !== "undefined";

  return {
    isTelegram: isRealTelegram,
    tgWebApp: tg,
  };
}

export default function useTelegram() {
  const [telegramState, setTelegramState] = useState(() => readTelegramState());

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    let cancelled = false;
    let pollTimer = 0;

    const syncTelegramState = () => {
      if (cancelled) return;
      setTelegramState((current) => {
        const next = readTelegramState();
        if (
          current.isTelegram === next.isTelegram &&
          current.tgWebApp === next.tgWebApp
        ) {
          return current;
        }
        return next;
      });
    };

    let attemptsLeft = 20;
    const startPolling = () => {
      pollTimer = window.setInterval(() => {
        syncTelegramState();
        attemptsLeft -= 1;

        if (attemptsLeft <= 0 || readTelegramState().tgWebApp) {
          window.clearInterval(pollTimer);
          pollTimer = 0;
        }
      }, 250);
    };

    syncTelegramState();
    window.addEventListener(TELEGRAM_READY_EVENT, syncTelegramState);
    startPolling();

    return () => {
      cancelled = true;
      window.removeEventListener(TELEGRAM_READY_EVENT, syncTelegramState);
      if (pollTimer) {
        window.clearInterval(pollTimer);
      }
    };
  }, []);

  return telegramState;
}
